import { HeardAboutUsType, PaymentProvider } from "~graphql/sdk";

export const HEARD_ABOUT_US_OPTIONS = [
  {
    value: HeardAboutUsType.Billboard,
    label: HeardAboutUsType.Billboard.toString(),
  },
  {
    value: HeardAboutUsType.Email,
    label: HeardAboutUsType.Email.toString(),
  },
  {
    value: HeardAboutUsType.Radio,
    label: HeardAboutUsType.Radio.toString(),
  },
  {
    value: HeardAboutUsType.SocialMedia,
    label: "Social Media",
  },
  {
    value: HeardAboutUsType.WordOfMouth,
    label: "Word of mouth / Friends / Family",
  },
  {
    value: HeardAboutUsType.InternetSearch,
    label: "Google / Internet search",
  },
  {
    value: HeardAboutUsType.Other,
    label: HeardAboutUsType.Other.toString(),
  },
] as const;

export type HeardAboutUsOption = (typeof HEARD_ABOUT_US_OPTIONS)[number];

export const TRAVEL_DEALS_OPTIONS = [
  { value: "No", label: "No" },
  { value: "Flights", label: "Flights" },
  { value: "Accommodation", label: "Accommodation" },
  { value: "Both", label: "Both" },
] as const;

export type TravelDealsOption = (typeof TRAVEL_DEALS_OPTIONS)[number];

export const PAYMENT_PROVIDER_OPTIONS = [
  { value: PaymentProvider.Eftpos, label: "Eftpos" },
  { value: PaymentProvider.Invoice, label: "Invoice" },
  { value: PaymentProvider.Cash, label: "Cash" },
  { value: PaymentProvider.Other, label: "Other" },
];

export type PaymentProviderOption = (typeof PAYMENT_PROVIDER_OPTIONS)[number];
